import { currentPage, initNewSection } from '../common/layout';
import { banners, hitPageView } from '../common/utils/fn';

import { getMakeModelFilter } from '../common/make-model-filter-loader';
import '../common/msnt/msnt-lightslider.js';
// import '../common/jquery.convertmosaic';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  let sideBarCollection =
    $('.m1-fullwidth-layout').length == 0
      ? '.sidebar:not(.top-block)'
      : '.sidebar';
  // $('#main_CR').convertMosaicToFilm();
  
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  getMakeModelFilter().then((api) => {
    api.makeModelFilter();
  });
};

currentPage.pageLoadMore = ($html, $btnBox) => {
  //$btnBox.replaceWith($html);
  initNewSection($html);
  
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  // fn.imgLazyload();
  banners($html);
  // fn.commentsCountUpdate(true);
  hitPageView(document.location.pathname);
  // bannerLazyload();
};
